import { useContext } from 'react';
import { LabelingContext } from './LabelingContext';

export function useLabeling() {
  const ctx = useContext(LabelingContext);
  if (!ctx) throw new Error('useLabeling must be used inside LabelingProvider');
  return ctx;
}
